module.exports = __webpack_public_path__ + "media/blink-trailer.59fc5177.mp4";